import { Component, OnInit } from '@angular/core';
import { SkillService } from '../services/skill.service';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { Location } from '@angular/common';
import { CategoryResponse, DepartmentResult, CategoryResult } from '../api-interfaces';
import 'rxjs/add/operator/takeUntil';
import { Subject, Observable } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { FlashService } from '../../flash/flash.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Component({
  selector: 'app-edit-skill',
  templateUrl: './edit-skill.component.html',
  styleUrls: ['./edit-skill.component.css']
})
export class EditSkillComponent implements OnInit {
  lists: Observable<CategoryResponse[]>
  departmentList: DepartmentResult[]
  categoryList: CategoryResult[];
  skillForm: FormGroup;
  skill;
  private destroy: Subject<void> = new Subject<void>();
  id: number;
  private sub: any;
  editData;
  categoryId;
  departmentId;

  constructor(
    public skillService: SkillService,
    private location: Location,
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private flashService: FlashService,
    private spinnerService: Ng4LoadingSpinnerService
  ) {
    this.lists = this.skillService.getCategory();
    this.skillForm = this.formBuilder.group({
      skill_name: new FormControl('', Validators.required),
      skill_id: new FormControl('', Validators.required),
      category_id: new FormControl('', Validators.required)
    });
  }

  ngOnInit() {
    // this.spinnerService.show();
    this.sub = this.route.params.subscribe(params => {
      this.id = +params['id'];
    });
    this.editData = this.skillService.editDataSkill;
    this.editData.category.forEach(data => {
      this.categoryId = data['category_id']
      this.departmentId = data['department'][0]['department_id']
    });
    this.getCategoryByDepartment(this.departmentId);
    this.skillForm.patchValue({
      'skill_name': this.editData.skill_name,
      'skill_id': this.editData.skill_id,
      'category_id': this.categoryId
    });
  }

  ngOnDestroy() {
    this.destroy.next();
    this.destroy.unsubscribe();
    this.sub.unsubscribe();
  }

  locationBack() {
    this.location.back();
  }

  newSkill(formData) {
    this.spinnerService.show();
    if (formData.valid) {
      this.skillService.updateNewSkill(formData.value).takeUntil(this.destroy)
        .subscribe(data => {
          this.spinnerService.hide();
          this.router.navigateByUrl('skillList')
        });
      this.flashService.show('Skill name is updated successfully', 'alert-success');
    }
    else {
      this.spinnerService.hide();
      this.flashService.show('Edit skill name or click cancel', 'alert-danger');
    }
  }

  getCategoryByDepartment(departmentId) {
    this.skillService.getCategoryDepartment().takeUntil(this.destroy)
      .subscribe(data => {
        this.departmentList = data;
        let categories = this.departmentList;
        for ( let row in categories ) {
          if ( categories[row].department_id == departmentId ) {
            this.categoryList = categories[row].category;
            break;
          }
        }
      });
  }

  trackByFn(index) {
    return index;
  }
}



// WEBPACK FOOTER //
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/skill-matrix/edit-skill/edit-skill.component.ts